// start:ng42.barrel
export * from './my-mazaya-plus.service';
// end:ng42.barrel

